/**
 * Created by Thomas Mark
 * Date: 28.05.2019
 * Description: text-Widget - Einzeilige Texteingabe
 *
 * Das text-Widget bietet die Möglichkeit einen Text in einer Zeile einzugeben.
 * Für mehrzeilige Texte steht das textarea-Widget zur Verfügung.
 *
 * Die Steuerung des Widgets basiert auf folgender Widget-Struktur:
 *
 "fields": [
    {
        "id": "lastname",
        "length": 200,
        "label": "Lastname",
        "unitLabel": "",
        "description": "Lastname",
        "placeholder": "Lastname",
        "field": "text",
        "maxItems": 0,
        "visibleItems": 0,
        "group": null,
        "value": 'Mark',
        "enums": []
        "validation": "^[A-Za-z0-9äöüÄÖÜß!\?\.\-§$%&\/\*\+#()_ ]*$",
        "validationState": null,
        "validationMessage": "invalid characters!"
    },
 *
 * Im text-Widget stehen folgende Widget-Attribute zur Verfügung:
 *
 * id            - Identifizierung des Feldes (muss eindeutig sein)
 * length        - Länge des Eingabefeldes bzw. Anzahl Zeichen
 * label         - Bezeichnung, die links neben dem Widget erscheint
 * unitLabel     - Mengeneinheit, die rechts neben dem Widget erscheint
 * description   - Genauere Beschreibung des Feldes, wird bei klick auf das Fragezeichen angezeigt
 * placeholder   - Text der im Eingabefeld erscheint, solange noch kein Wert eingegeben wurde
 * field         - Bezeichnung des Widgets. Hier mit "text" belegt
 * maxItems      - Maximale Anzahl an auswählbaren Werten/Zeichen (hier ohne Bedeutung)
 * visibleItems  - Anzahl sichtbarer Werte in beiden Listen. Existieren mehr Werte, so erscheint ein vertikaler Scrollbalken
 * group         - Gruppenzuordnung (siehe dialog.group)
 * value         - Aktueller Text
 * enums         - Alle Auswahlmöglichkeiten (hier ohne Bedeutung)
 * validation    - RegEx zur Validierung der Eingabe
 * validationState   - Zustand der Validierung
 * validationMessage - Fehlermeldung, falls Validierung erfolglos
 *
 * Der Komponente können folgende Eigenschaften/Werte übergeben werden:
 * field - field-Object
 * value - aktueller Wert
 * type - input-type. Wird an das input-Tag weitergeleitet
 * icon - Bezeichnung des Icons, das rechts neben dem Eingabefeld erscheint.
 * onChange - callback-Funktion. Wird aufgerufen, wenn sich der Wert im Feld verändert
 * onKeyPress - callback-Funktion. Wird aufgerufen, wenn eine Taste gedrückt wurde
 * onBlur - callback-Funktion. Wird aufgerufen, wenn das Feld verlassen wird
 *
 */
import React from 'react';
import { MdInsertLink, MdMailOutline, MdDateRange, MdAccessTime } from 'react-icons/md'

const Text = ({ field, value, type, icon, onChange, onKeyPress, onBlur }) => {

    //console.log("Text() field:", field);

    let iconPath = null;

    switch (icon) {
        case 'link': iconPath = <MdInsertLink className="fill-current h-12 w-12" />; break;
        case 'email': iconPath = <MdMailOutline className="fill-current h-12 w-12" />; break;
        case 'date': iconPath = <MdDateRange className="fill-current h-12 w-12" />; break;
        case 'time': iconPath = <MdAccessTime className="fill-current h-12 w-12" />; break;
        default: iconPath = ""; break;
    }

    return (
        <div className="inline-block relative h-full w-full">
            <input type={type}
                className="bg-gray-200 appearance-none rounded h-12 w-full px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                id={field.id}
                disabled={field.disabled}
                value={value}
                size={field.length}
                onChange={(e) => onChange(e, e.target.value)}
                onKeyPress={onKeyPress}
                onBlur={onBlur}
                placeholder={field.placeholder}>
            </input>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center text-gray-700">
                {iconPath}
            </div>
        </div>
    )
};

export default Text